import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Option from "./common/Option";

const ExportModal = ({ show, handleClose, onSubmit }) => {
  const [sort, setSort] = useState("asc");

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="bg-primary text-white">
        <h3>Export Data</h3>
      </Modal.Header>
      <Modal.Body>
        <div className="row my-3">
          <div className="col">
            <Option
              name="asc"
              label="Ascending (Oldest First)"
              checked={sort === "asc"}
              onClick={() => setSort("asc")}
            />
          </div>
          <div className="col">
            <Option
              name="desc"
              label="Descending (Newest First)"
              checked={sort === "desc"}
              onClick={() => setSort("desc")}
            />
          </div>
        </div>
        <div className="d-flex justify-content-around">
          <button
            className="btn btn-lg btn-success"
            onClick={() => onSubmit(false, sort)}
          >
            <i className="fas fa-arrow-right"></i> Parameters
          </button>
          <button
            className="btn btn-lg btn-outline-warning"
            onClick={() => onSubmit(true, sort)}
          >
            <i className="fas fa-arrow-down"></i> Parameters
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExportModal;
